import React, { useState } from 'react';
import './../../entrydoor.css';

const CasingSize = ({ value, onChange, label = 'Casing Size' }) => {
    const [selectedCasingSize, setSelectedCasingSize] = useState(value || "");

    const handleCasingSizeChange = (e) => {
        const newValue = e.target.value;
        setSelectedCasingSize(newValue); // Update local state
        onChange(newValue); // Call onChange prop with the new value
    };

    return (
        <div className="a-container">
            <label  style={{ display: "none" }} htmlFor="CasingSize">{label}</label>
            <select style={{ display: "none" }}
                id="CasingSize"
                value={selectedCasingSize}
                onChange={handleCasingSizeChange}
            >
              <option value="" disabled hidden>Select an option</option>  
              <option value='2 3/4"'>{selectedCasingSize === '2 3/4"' ? '2 3/4" ✔' : '2 3/4"'}</option>
              <option value='3 1/2"'>{selectedCasingSize === '3 1/2"' ? '3 1/2" ✔' : '3 1/2"'}</option>
            </select>
        </div>
    );
};

export default CasingSize;
